/**
 * Wrapper "Histórico de treinos" — título + WorkoutCalendar do aluno.
 *
 * Mostra ao personal a MESMA visão que o aluno vê no dashboard dele
 * (calendário com treinos planejados vs. realizados). Não tem
 * interatividade especial — só leitura.
 *
 * Props:
 *   - studentId: id do aluno (passado direto pro calendário)
 *
 * Quando NÃO usar: se for outra tela do app que precisa só do
 * calendário sem o título, use WorkoutCalendar direto.
 */

import { memo } from 'react';
import { Text } from 'react-native';
import { WorkoutCalendar } from '@/components/WorkoutCalendar';
import { sharedStyles } from './styles';

interface Props {
  studentId: string;
}

function HistorySectionImpl({ studentId }: Props) {
  return (
    <>
      <Text style={sharedStyles.sectionTitle}>Histórico de treinos</Text>
      <WorkoutCalendar studentId={studentId} />
    </>
  );
}

export const HistorySection = memo(HistorySectionImpl);
